import React from 'react'
import {ApolloProvider} from 'react-apollo'
import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import SessionCookies from '../../modules/common/utils/sessionCookies'
import {UserContextProvider} from '../../context/UserContext'
import {ToastMessageContextProvider} from '../../context/ToastMessage'
import {BarcodeUrlSkipProvider} from '../../context/BarcodeUrlSkip'
import {BarcodeUserSettingsContextProvider} from '../../context/BarcodeUserSettings'
import {BarcodeLabelRecordContextProvider} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContextProvider} from '../../context/BarcodeSheetRecord'
import {BarcodeWizardContextProvider} from '../../context/BarcodeWizard'

const link = createHttpLink({
  uri: process.env.REACT_APP_BARCODE_API_URL,
})

const client = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
})

function BarcodeInitialize({children}) {
  return (
    <SessionCookies>
      <UserContextProvider>
        <ToastMessageContextProvider>
          <ApolloProvider client={client}>
            <BarcodeUserSettingsContextProvider>
              <BarcodeLabelRecordContextProvider>
                <BarcodeSheetRecordContextProvider>
                  <BarcodeWizardContextProvider>
                    <BarcodeUrlSkipProvider>{children}</BarcodeUrlSkipProvider>
                  </BarcodeWizardContextProvider>
                </BarcodeSheetRecordContextProvider>
              </BarcodeLabelRecordContextProvider>
            </BarcodeUserSettingsContextProvider>
          </ApolloProvider>
        </ToastMessageContextProvider>
      </UserContextProvider>
    </SessionCookies>
  )
}

export default BarcodeInitialize
